var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.732 21a4.725 4.725 0 01-3.347-1.44C3.462 18.6 3 17.4 3 16.08c0-1.32.462-2.52 1.385-3.48l2.193-2.28c.23-.24.577-.24.808 0 .23.24.23.6 0 .84l-2.193 2.28c-.693.72-1.039 1.56-1.039 2.64S4.5 18 5.193 18.72c1.385 1.44 3.693 1.44 4.962 0l2.193-2.28c.23-.24.577-.24.808 0 .23.24.23.6 0 .84l-2.193 2.28c-.808.96-1.962 1.44-3.231 1.44zm8.771-7.32c-.116 0-.346 0-.462-.12a.596.596 0 010-.84l2.193-2.28a3.723 3.723 0 000-5.16c-1.385-1.44-3.578-1.44-4.963 0L11.08 7.56a.543.543 0 01-.808 0 .596.596 0 010-.84l2.192-2.28c1.847-1.92 4.732-1.92 6.579 0a4.915 4.915 0 010 6.84l-2.193 2.28c-.115.12-.23.12-.346.12z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73 16.8c-.115 0-.346 0-.461-.12a.596.596 0 010-.84l7.963-8.28c.23-.24.577-.24.808 0 .23.24.23.6 0 .84l-7.963 8.28s-.116.12-.347.12z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLink);
export default __webpack_public_path__ + "static/media/white-link.edc7956aff6006189bf3f08e64df0fbe.svg";
export { ForwardRef as ReactComponent };